export var ManageTokensStates;
(function (ManageTokensStates) {
    ManageTokensStates["ManageTokens"] = "dashboard.settings.manage-tokens";
    ManageTokensStates["ApiTokens"] = "dashboard.settings.manage-tokens.api";
    ManageTokensStates["SharedTokens"] = "dashboard.settings.manage-tokens.shared";
    ManageTokensStates["LogShippingTokens"] = "dashboard.settings.manage-tokens.log-shipping";
    ManageTokensStates["DataShippingTokens"] = "dashboard.settings.manage-tokens.data-shipping";
})(ManageTokensStates || (ManageTokensStates = {}));
//# sourceMappingURL=manage-tokens.enum.js.map